import styled from 'styled-components';

export const OneLine = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;
